/*
 * This file contains the floorplan special component.
 */

import { getSpecialsList } from "../../../utils/util";
import Tooltip from "../../Tooltip/tooltip";
import styles from "../floorplans.module.scss";

export default function FloorplanSpecialComponent({
  typeListing,
  specials,
  fpId,
}) {
  // This function fetches the list of specials for the floorplan.
  const specialsList = getSpecialsList(specials);

  if (typeListing) {
    // This conditional checks if the fpId is not in the specialsList.
    if (!specialsList?.includes(fpId)) {
      return null;
    } else {
      return (
        <div className={styles.FloorplanSpecialComponent}>
          <Tooltip text={specials?.floorplan[specialsList[0]]?.description}>
            <span className={styles.specialsInfo}>
              Special Offer{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#9b673b"
                width="64px"
                height="64px"
                viewBox="0 0 32 32"
                stroke="#9b673b"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0" />
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g id="SVGRepo_iconCarrier">
                  <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z" />
                </g>
              </svg>
            </span>
          </Tooltip>
        </div>
      );
    }
  } else {
    // This conditional checks if the fpId is not in the specialsList.
    if (!specialsList?.some((id) => fpId === id)) {
      return null;
    } else {
      return (
        <div className={styles.FloorplanSpecialComponent}>
          <Tooltip text={specials?.floorplan[fpId]?.description}>
            <span className={styles.specialsInfo}>
              Special Offer{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#9b673b"
                width="64px"
                height="64px"
                viewBox="0 0 32 32"
                stroke="#9b673b"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0" />
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g id="SVGRepo_iconCarrier">
                  <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z" />
                </g>
              </svg>
            </span>
          </Tooltip>
        </div>
      );
    }
  }
}
